import { render } from "./InputID.vue?vue&type=template&id=6367e9c8"
import script from "./InputID.vue?vue&type=script&lang=js"
export * from "./InputID.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__